import { Search } from "@mui/icons-material";
import { Box, InputAdornment, TextField, useMediaQuery } from "@mui/material";
import React, { useState, useEffect } from "react";

const SearchBox = ({
  search,
  setSearch,
  startSearch,
  loading,
  searchLoading,
}) => {
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const mediumScreen = useMediaQuery((theme) =>
    theme.breakpoints.between("sm", "lg"),
  );

  const [inputValue, setInputValue] = useState(search);

  useEffect(() => {
    setInputValue(search);
  }, [search]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        mt: 1,
        mb: 1,
        mx: smallScreen ? 2 : mediumScreen ? "50px" : "200px",
      }}
    >
      <TextField
        variant="outlined"
        placeholder="Search..."
        value={inputValue}
        onChange={(e) => {
          setInputValue(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" && inputValue.length > 0) {
            if (loading || searchLoading) {
              return;
            } else {
              setSearch(inputValue);
              startSearch(inputValue);
            }
          }
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: { xs: "9px", xl: "12px" },
            height: { xs: "50px", xl: "56px" },
            backgroundColor: "#fff",
            boxShadow: "0px 0px 6.9px 0px #0000001F",
            fontSize: { xs: "14px", xl: "17px" },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "#FFB79C",
              borderWidth: "1px",
            },
            "& fieldset": {
              borderColor: "#FFB79C",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#FFB79C",
            },
          },
          "& .MuiOutlinedInput-input": {
            fontSize: { xs: "14px", xl: "17px" },
          },
          "& .MuiOutlinedInput-input::placeholder": {
            opacity: 0.24,
            fontFamily: "Poppins-Regular",
            fontSize: { xs: "14px", xl: "17px" },
            fontWeight: 400,
            lineHeight: "18px",
            color: "#1C1C1C",
          },
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment
              position="end"
              onClick={() => {
                if (inputValue.length > 0) {
                  if (loading || searchLoading) {
                    return;
                  } else {
                    setSearch(inputValue);
                    startSearch(inputValue);
                  }
                }
              }}
            >
              <Search sx={{ color: "#e1e1e1", fontSize: { xs: "24px", xl: "28px" } }} />
            </InputAdornment>
          ),
        }}
        fullWidth
      />
    </Box>
  );
};

export default SearchBox;
